<button mat-icon-button (click)="fileInput.click()" type="button" *ngIf="!disabled" >
  <mat-icon>upload_file</mat-icon>
</button>
<input hidden="true" multiple type="file" #fileInput (change)="onFileChange($event)" accept="audio/mpeg3"/>
{{ filename }}
